export enum LiveOption {
  LIVE_DATA = 'LIVE_DATA',
  LIVE_STREAM = 'LIVE_STREAM'
}
